import { httpPost } from "utils/httpRequest"

const getNpsQuestions = async () => {
  const resp = await httpPost("admin/npsQuestion/list")
  return resp.data
}

const addNpsQuestion = async ({ questionText, versionLabel, targetTiers, isActive, minDaysSinceRegistration }) => {
  const resp = await httpPost("admin/npsQuestion/add", {
    questionText,
    versionLabel,
    targetTiers,
    isActive,
    minDaysSinceRegistration,
  })
  return resp.data
}

const editNpsQuestion = async ({ id, questionText, versionLabel, targetTiers, isActive, minDaysSinceRegistration }) => {
  const resp = await httpPost("admin/npsQuestion/edit", {
    id,
    questionText,
    versionLabel,
    targetTiers,
    isActive,
    minDaysSinceRegistration,
  })
  return resp.data
}

const toggleNpsQuestionStatus = async ({ id }) => {
  const resp = await httpPost("admin/npsQuestion/toggleStatus", { id })
  return resp.data
}

const deleteNpsQuestion = async ({ id }) => {
  const resp = await httpPost("admin/npsQuestion/delete", { id })
  return resp.data
}

export {
  getNpsQuestions,
  addNpsQuestion,
  editNpsQuestion,
  toggleNpsQuestionStatus,
  deleteNpsQuestion,
}
